module.exports = __webpack_public_path__ + "img/105.e2c8bcda.jpg";